module.exports = __webpack_public_path__ + "img/songzi.ba908f9b.png";